import React, { Fragment, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import {
  getDevice,
  getDeviceUsagebyId,
  getFirmwareHistory,
  getOnboardedHistory,
  getDiagnosticsData,
} from "../../action/report";
import { getUserById, clearUserById } from "../../action/user";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { getWarrantyInfo, clearWarrantyData } from "../../action/warranty";
import Alert from "../layout/Alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import DeviceDetails from "../device/DeviceDetails";
import "./DeviceDetails.css";
import UserInfo from "../dashboard/UserInfo";
import customConfig from "../../config";
import { selectMenuProps } from "../../utils/selectMenuProps";
import BarcodeScanner from "../Common/scanner/BarcodeScanner";
import { getQRDetailsUsingScanner } from "../../action/qrcode";
import { setAlert } from "../../action/alert";
import Grid2 from "@mui/material/Grid2";
import { SearchSectionLabel, SectionHeading, LabelText } from "../Common/Typography/AppTypography";
import Paper from "@mui/material/Paper";
import DeviceUpdateLogs from "./DeviceUpdateLogs";
import DeviceDiagnostics from "./DeviceDiagnostics/DeviceDiagnostics";
import DeviceConnDisconnLogs from "./DeviceConnDisconn/DeviceConnDisconnLogs";
import { downloadDeviceDiagnosticReport, downloadDeviceStatusReport, getDeviceConnDisconnLogsData, getDeviceDACLogsData, getDeviceDiagnosticsData, getDeviceStatusData } from "../../action/devicelogs";
import DeviceStatus from "./DeviceStatus/DeviceStatus";
import { getFormatedJSON } from "../../utils/general";
import Dialog from "../Common/Dailog/Dailog";
import { getDeviceLogPermission } from "./DeviceLogsConstants";
import DeviceDACLogs from "./DACStatistics/DeviceDACLogs/DeviceDACLogs";
import FormInput from "../Common/FormInputs/MuiTextField";
import AppButton from "../Common/Button/Button";
import AppIconButton from "../Common/Button/IconButton";
import AppTabs from "../Common/Tabs/AppTabs";
import SearchIcon from "@mui/icons-material/Search";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { useDesignTokens } from "../../theme/useDesignTokens";

const tabContainerSx = {
  "& .MuiTabs-fixed": { overflow: 'auto !important', width: '100%' },
  "& .MuiTab-root .MuiTouchRipple-root .MuiTouchRipple-child": { backgroundColor: 'rgba(237, 108, 2, 0.3) !important' },
};
const SearchDevice = ({
  setAlert,
  deviceId,
  getDevice,
  getDeviceUsagebyId,
  getFirmwareHistory,
  getUserById,
  clearUserById,
  getOnboardedHistory,
  getWarrantyInfo,
  clearWarrantyData,
  getDiagnosticsData,
  getDeviceDiagnosticsData,
  downloadDeviceDiagnosticReport,
  getDeviceConnDisconnLogsData,
  getDeviceStatusData,
  getDeviceDACLogsData,
  downloadDeviceStatusReport,
  DeviceData: {
    device,
    deviceUsage,
    latestFirmwareData,
    firmwareData,
    onBoardedHistoryData,
    diagnosticData,
    deviceLogs,
    report
  },
  UserData: { userById },
  // Use responsive wrapper for all states; avoid legacy fixed-width class
  wrapperClass = "",
  searchBarWrapperClass = "",
  userRoleInfo,
  tenantInfo,
  /** When true, skip ResponsiveContentWrapper - used when embedded (e.g. inside ManufacturedDevices) */
  embedded = false,
  /** Optional content to render before the search block - e.g. Back button for aligned layout */
  prependContent,
}) => {
  const tabs = [{ label: 'Device Info', permission: "deviceInfo" }, { label: "DAC Logs", permission: "dacLogs" }, { label: "Device Logs", permission: 'deviceLogs' }, { label: "Connection Status Logs", permission: "connectionStatusLogs" }, { label: "Diagnostic Logs", permission: "diagnosticLogs" }, { label: "Status Logs", permission: "statusLogs" }]
  const theme = useTheme();
  const [activeTab, setActiveTab] = React.useState(0)

  const location = useLocation();
  const searchInitiated = useRef(false);
  const [text, setText] = useState("");
  const [showText, setShowText] = useState(false);
  const [searchBy, setSearchBy] = useState(customConfig.deviceSearchByDeviceId);
  const [searchByPlaceHolder, setSearchByPlaceHolder] =
    useState("Enter Device Id");
  const [withoutOnboard, setWithoutOnboard] = useState(false);

  const [displayScanner, setDisplayScanner] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [dialogContents, setDialogContents] = useState({ title: '', data: {} });
  const [availableTabs, setAvailableTabs] = React.useState([]);
  const [selectedTab, setSelectedTab] = React.useState(availableTabs[0]);

  useEffect(() => {
    if (deviceId) {
      clearUserById();
      setText(deviceId);
      setShowText(false);
      setWithoutOnboard(false);
      device = null;
      searchInitiated.current = true;
      getDevice(deviceId, customConfig.deviceSearchByDeviceId, userRoleInfo, tenantInfo.tenantId);
    }
    else {
      if (!showText && location.state) {
        setShowText(true);
      }
    }
  }, []);

  useEffect(() => {
    const visibleTabs = tabs?.filter(t => {
      return getDeviceLogPermission(userRoleInfo?.roles, t?.permission)
    })?.map(t => t?.label)
    setAvailableTabs(visibleTabs)
    setSelectedTab(visibleTabs[0])
  }, [userRoleInfo?.roles])

  useEffect(() => {
    if (text.length > 0 && device && device.length > 0) {
      const userId = device[0].onboardedById;

      if (!(userRoleInfo.level===0 && userRoleInfo.roles.includes(customConfig.roleFactoryAdmin))) {
        if (userId && userId.length > 0) {
          getUserById(userId, tenantInfo.tenantId);
        } else {
          setWithoutOnboard(true);
        }
      }

      const devId = device[0].deviceId;

      if (!(userRoleInfo.level===0 && userRoleInfo.roles.includes(customConfig.roleFactoryAdmin))) {
        getFirmwareHistory(devId);
        getOnboardedHistory(devId);
        getDiagnosticsData(devId);
        getDeviceUsagebyId(devId);
      }

      setShowText(true);
      setText("");
    }
  }, [device]);

  useEffect(() => {
    if (searchInitiated.current) {
      // Get eWarranty auth token and Product List
      if (userById && userById.mobile) {
        getWarrantyInfo(userById.mobile);
      } else {
        clearWarrantyData();
      }
    }
  }, [userById]);

  const onSubmit = (e) => {
    e.preventDefault(true);
    setActiveTab(0)
    clearUserById();
    setShowText(false);
    setWithoutOnboard(false);
    device = null;
    searchInitiated.current = true;
    getDevice(text, searchBy, userRoleInfo, tenantInfo.tenantId);
  };

  const onChange = (e) => setText(e.target.value);

  const searchByLabels = {
    [customConfig.deviceSearchByDeviceId]: "Device Id",
    [customConfig.deviceSearchByMacAddress]: "Mac Address",
    [customConfig.deviceSearchByProductSerialNumber]: "Product Serial No.",
  };
  const changeSearchBy = (e) => {
    const value = e.target.value;
    setSearchBy(value);
    setText("");
    setSearchByPlaceHolder(`Enter ${searchByLabels[value] || value}`);
    device = {};
    setShowText(false);
  };

  const handleNotifyOffboard = () => {
    setShowText(false);
  };

  function handleScanQRcodeAndBarcode() {
    setDisplayScanner(!displayScanner)
  }

  function handleQRCodeScanDetails(data) {
    clearUserById();
    setShowText(false);
    setWithoutOnboard(false);
    device = null;

    if (data.toString().substring(0, 2)==="MT") {
      //qrcode
      getQRDetailsUsingScanner(data)
        .then((qrCodeScannedResult) => {
          if (qrCodeScannedResult.productSerialNumber) {
            setText(qrCodeScannedResult.productSerialNumber)
            getDevice(qrCodeScannedResult.productSerialNumber, customConfig.deviceSearchByProductSerialNumber, userRoleInfo, tenantInfo.tenantId)
          }
          else {
            setAlert("Cannot Scan QR Code. Scanned QR Code is Model ID Based QR Code", "danger")
          }

        })
        .catch((error) => {
          setAlert("Failed to Scan QR Code", "danger")
        })
    }
    else {
      // scanned data is product serial number using barcode
      setText(data)
      getDevice(data, customConfig.deviceSearchByProductSerialNumber, userRoleInfo, tenantInfo.tenantId);
    }
  }

  const fieldHeight = 45;
  const { colors } = useDesignTokens();
  const primaryColor = colors?.primary?.main || theme.palette.primary.main;
  const focusOutlineSx = {
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${primaryColor} !important`,
      borderWidth: "1px",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: `${primaryColor} !important`,
    },
  };

  const content = (
    <Fragment>
      <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
        <Grid2 container spacing={2}>
          {prependContent && (
            <Grid2 size={12}>
              {prependContent}
            </Grid2>
          )}
          <Grid2 size={12}>
            <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mb: 0 }}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", lg: "auto 1fr" },
                  rowGap: 2,
                  columnGap: { xs: 2, lg: "116px" },
                  alignItems: "center",
                }}
              >
              <SectionHeading sx={{ mb: 0 }}>
                Search Device
              </SectionHeading>
              <Box
                component="form"
                onSubmit={onSubmit}
                sx={{
                  display: "grid",
                  gap: 1.5,
                  gridTemplateColumns: { xs: "1fr", sm: "1fr", lg: "90px 200px minmax(220px,320px) auto" },
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "start",
                }}
              >
                <SearchSectionLabel>Search By</SearchSectionLabel>
                <FormInput
                  type="select"
                  size="small"
                  fullWidth
                  name="searchBy"
                  value={searchBy}
                  onChange={changeSearchBy}
                  options={[
                    { value: customConfig.deviceSearchByDeviceId, label: "Device Id" },
                    { value: customConfig.deviceSearchByMacAddress, label: "Mac Address" },
                    { value: customConfig.deviceSearchByProductSerialNumber, label: "Product Serial No." },
                  ]}
                  MenuProps={selectMenuProps}
                  sx={{
                    minWidth: { xs: "100%", sm: "100%", lg: 200 },
                    maxWidth: { xs: "100%", sm: "100%", lg: 200 },
                    "& .MuiOutlinedInput-root": { height: fieldHeight },
                    ...focusOutlineSx,
                  }}
                />
                <FormInput
                  type="text"
                  name="text"
                  placeholder={searchByPlaceHolder}
                  value={text}
                  onChange={onChange}
                  size="small"
                  fullWidth
                  margin="none"
                  startAdornment={<SearchIcon fontSize="small" />}
                  sx={{
                    margin: 0,
                    "& .MuiOutlinedInput-root": { height: fieldHeight },
                    ...focusOutlineSx,
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: { xs: "wrap", lg: "nowrap" },
                    width: { xs: "100%", lg: "auto" },
                  }}
                >
                  <AppButton
                    type="submit"
                    variant="primary"
                    size="medium"
                    sx={{
                      minWidth: { xs: 80, sm: 100 },
                      width: { xs: "100%", lg: "auto" },
                    }}
                  >
                    Search
                  </AppButton>
                  <AppIconButton
                    onClick={handleScanQRcodeAndBarcode}
                    size="large"
                    variant="ghost"
                    tooltip="Click to Scan QR Code or Barcode"
                    icon={<QrCode2Icon fontSize="large" />}
                    sx={{
                      color: "black",
                      width: 48,
                      height: 48,
                      flexShrink: 0,
                      "& .MuiSvgIcon-root": { fontSize: 32 },
                    }}
                    aria-label="Scan QR Code or Barcode"
                  />
                </Box>
              </Box>
              </Box>
              {displayScanner && (
                <Box sx={{ mt: 5 }}>
                  <BarcodeScanner scanDetailsHandler={handleQRCodeScanDetails} />
                  <LabelText sx={{ mt: 0.5 }}>QR Code or Barcode Scanner</LabelText>
                </Box>
              )}
            </Paper>
          </Grid2>
        </Grid2>
        <Box sx={{ my: 2 }}>
          <Alert />
        </Box>
        {showText && device && Object.keys(device).length > 0 && (
          <Box sx={{ width: "100%", minWidth: 0, mt: 0, pt: 0 }}>
            {!(userRoleInfo.level === 0 && userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)) &&
              (userById || withoutOnboard) && (
                <Box sx={{ mb: 2 }}>
                  <UserInfo user={userById} withoutOnboard={withoutOnboard} />
                </Box>
              )}
            <Box className="search-device-tabs" sx={{ mt: 1.5, ...tabContainerSx }}>
              <AppTabs
                value={activeTab}
                onChange={(e, newValue) => {
                  setActiveTab(newValue);
                  setSelectedTab(availableTabs[newValue]);
                }}
                tabs={availableTabs?.map((label) => ({ label }))}
                variant="scrollable"
                scrollButtons="auto"
                tabsSx={{ mt: 2 }}
              />
            </Box>

            {(() => {
              switch (selectedTab) {
                case "Device Info":
                  return (
                    <Box sx={{ width: "100%", minWidth: 0, mt: 2, mb: 2 }}>
                      <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1 }}>
                        <DeviceDetails
                          device={device}
                          deviceUsage={deviceUsage}
                          latestFirmwareData={latestFirmwareData}
                          firmwareData={firmwareData}
                          onBoardedHistoryData={onBoardedHistoryData}
                          diagnosticData={diagnosticData}
                          notifyOffboard={handleNotifyOffboard}
                          compactLayout
                        />
                      </Paper>
                    </Box>
                  );
                case "DAC Logs":
                  return (
                    <DeviceDACLogs
                      getDeviceDACLogsData={getDeviceDACLogsData}
                      dacData={deviceLogs}
                      deviceDetails={device ? (device.length > 1 ? device[1] : device[0]) : {}}
                    />
                  );
                case "Device Logs":
                  return <DeviceUpdateLogs deviceDetails={device ? (device.length > 1 ? device[1] : device[0]) : {}} />;
                case "Connection Status Logs":
                  return (
                    <DeviceConnDisconnLogs
                      connectionStatusLogs={deviceLogs}
                      getDeviceConnDisconnLogsData={getDeviceConnDisconnLogsData}
                      deviceDetails={device ? (device.length > 1 ? device[1] : device[0]) : {}}
                    />
                  );
                case "Diagnostic Logs":
                  return (
                    <DeviceDiagnostics
                      setDialog={setDialog}
                      setDialogContents={setDialogContents}
                      diagnosticData={deviceLogs}
                      deviceDetails={device ? (device.length > 1 ? device[1] : device[0]) : {}}
                      getDeviceDiagnosticsData={getDeviceDiagnosticsData}
                      downloadDeviceDiagnosticReport={downloadDeviceDiagnosticReport}
                    />
                  );
                case "Status Logs":
                  return (
                    <DeviceStatus
                      setDialog={setDialog}
                      setDialogContents={setDialogContents}
                      statusData={deviceLogs}
                      deviceDetails={device ? (device.length > 1 ? device[1] : device[0]) : {}}
                      getDeviceStatusData={getDeviceStatusData}
                      downloadDeviceStatusReport={downloadDeviceStatusReport}
                    />
                  );
                default:
                  return null;
              }
            })()}
          </Box>
        )}
        <Dialog
          open={dialog}
          onClose={() => setDialog(false)}
          title={dialogContents?.title}
          showCloseButton
          actions={[{ label: "Close", variant: "ghost", onClick: () => setDialog(false) }]}
          sx={{ zIndex: "2400 !important" }}
          titleSx={{ backgroundColor: "#f4f4f4", fontSize: "16px !important" }}
          PaperProps={{ sx: { maxWidth: 800 } }}
        >
          <Box sx={{ maxWidth: 800, minHeight: 280, maxHeight: 400, overflowY: "auto" }}>
            {getFormatedJSON(dialogContents?.data)}
          </Box>
        </Dialog>
      </Box>
    </Fragment>
  );

  return embedded ? content : <ResponsiveContentWrapper className={wrapperClass}>{content}</ResponsiveContentWrapper>;
};

const mapStateToProps = (state) => ({
  DeviceData: state.report,
  UserData: state.user,
  userRoleInfo: {
    level: state.auth.userLevel,
    roles: state.auth.userRoles,
  },
  tenantInfo: state.tenant.tenantInfo,
});

const mapDispatchToProps = (dispatch) => ({
  getDevice: (arg1, arg2, arg3, arg4, arg5) => dispatch(getDevice(arg1, arg2, arg3, arg4, arg5)),
  getDeviceUsagebyId: (arg1) => dispatch(getDeviceUsagebyId(arg1)),
  getFirmwareHistory: (arg1) => dispatch(getFirmwareHistory(arg1)),
  getOnboardedHistory: (arg1) => dispatch(getOnboardedHistory(arg1)),
  getUserById: (arg1, arg2, arg3) => dispatch(getUserById(arg1, arg2, arg3)),
  clearUserById: () => dispatch(clearUserById()),
  getWarrantyInfo: (arg1) => dispatch(getWarrantyInfo(arg1)),
  clearWarrantyData: () => dispatch(clearWarrantyData()),
  getDiagnosticsData: (arg1) => dispatch(getDiagnosticsData(arg1)),
  setAlert: (message, status) => dispatch(setAlert(message, status)),
  getDeviceConnDisconnLogsData: (deviceId, cb) => { dispatch(getDeviceConnDisconnLogsData(deviceId, cb)) },
  getDeviceDiagnosticsData: (params, cb) => { dispatch(getDeviceDiagnosticsData(params, cb)) },
  getDeviceDACLogsData: (params, cb) => { dispatch(getDeviceDACLogsData(params, cb)) },
  downloadDeviceDiagnosticReport: (params, cb) => { dispatch(downloadDeviceDiagnosticReport(params, cb)) },
  getDeviceStatusData: (params, cb) => { dispatch(getDeviceStatusData(params, cb)) },
  downloadDeviceStatusReport: (params, cb) => { dispatch(downloadDeviceStatusReport(params, cb)) }

})

export default connect(mapStateToProps, mapDispatchToProps)(SearchDevice);
